import React from "react";

import { Dropdown, MenuItem } from "react-bootstrap";

export default class Footer extends React.Component {
  render() {
    return (
      <div className="page-footer">
        <div className="row">
          <div className="col-xs-12">
            <span className="txt-color-white">

            </span>
          </div>
        </div>
      </div>
    );
  }
}
